import { Box } from '@mui/material';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import SalesRepDashboard from '../SalesRepDashboard';

/**
 * The Thread style of the sales rep home: my own deals as steps from quotation to payment, with my deliveries of the week on the side.
 * The server narrows everything to the caller's own records and leaves out any section the caller has no key for, so this stays a thin wrapper.
 */
export default function SalesRepLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.salesRep">
            <RoleLensBoard institutionId={institutionId} lens="salesRep" fallback={<SalesRepDashboard />} />
        </Box>
    );
}
